import {isoToLocalInputValue} from '../journal/schedule.js';
import {button,escapeHtml,message,panel,statusPill} from '../ui/components.js';
import {emptyState,errorState,loadingState} from '../ui/states.js';

function statusLabel(status){
  const labels={
    draft:'Szkic',
    planned:'Zaplanowane',
    preparation:'Przygotowanie',
    ready:'Gotowe'
  };
  return labels[String(status||'')]||String(status||'');
}

function formatInstant(value,timeZone){
  if(!value)return 'czas nieustalony';
  return new Intl.DateTimeFormat('pl-PL',{
    timeZone,
    weekday:'short',
    year:'numeric',
    month:'short',
    day:'2-digit',
    hour:'2-digit',
    minute:'2-digit'
  }).format(new Date(value));
}

function durationLabel(value){
  const minutes=Number(value);
  if(!Number.isFinite(minutes)||minutes<=0)return 'czas nieustalony';
  const h=Math.floor(minutes/60),m=minutes%60;
  if(!h)return m+' min';
  return m?h+' h '+m+' min':h+' h';
}

function selectOption(value,label,current){
  return '<option value="'+escapeHtml(value)+'"'+(String(value)===String(current)?' selected':'')+'>'+escapeHtml(label)+'</option>';
}

function sessionCard(session){
  const meta=[
    statusLabel(session.status),
    session.recipeDerived?'z receptury':'własny plan',
    session.plannedStartAt?'ma termin':'bez terminu'
  ];
  return '<article class="panel planner-session-card"><div><strong>'+escapeHtml(session.title)+'</strong>'
    +'<p class="panel-copy">'+escapeHtml(meta.join(' · '))+'</p></div>'
    +button({label:'Planuj na godzinę',variant:'secondary',attributes:{'data-planner-session':session.id}})
    +'</article>';
}

function listMarkup(state){
  const sessions=state.sessions||[];
  return '<section class="planner-list">'
    +message({text:state.notice||'',kind:state.noticeKind||'neutral'})
    +panel({
      title:'Kiedy ma być gotowe?',
      subtitle:'Wybierz istniejący szkic lub plan. Receptura użyta wcześniej do utworzenia szkicu też działa w tym samym przepływie.',
      body:sessions.length
        ?'<div class="planner-session-list">'+sessions.map(sessionCard).join('')+'</div>'
        :emptyState({
          title:'Najpierw utwórz szkic wędzenia',
          text:'Smart Planner pracuje na edytowalnym szkicu lub zaplanowanym wędzeniu. Recepturę możesz najpierw użyć do utworzenia szkicu.'
        })+'<div class="actions"><a class="button button-primary" href="#/smokings">Przejdź do Wędzeń</a><a class="button button-secondary" href="#/recipes">Użyj receptury</a></div>'
    })
    +'</section>';
}

function setupMarkup(state){
  const smokerOptions=['<option value="">Nie wybrano — sprawdź ręcznie</option>'];
  for(const smoker of state.smokers||[]){
    smokerOptions.push(selectOption(smoker.id,smoker.name||'Wędzarnia',state.selectedSmokerId||''));
  }
  const timezoneWarning=state.timezoneReview?.requiresReview
    ?message({
      text:'Ten plan był zapisany w strefie '+state.timezoneReview.originatingTimeZone
        +', a urządzenie używa '+state.timezoneReview.currentTimeZone
        +'. Docelowa godzina wyświetla się teraz jako '+state.timezoneReview.currentTargetLocal
        +' zamiast '+state.timezoneReview.originatingTargetLocal+'. Wygeneruj plan ponownie po sprawdzeniu czasu.',
      kind:'warning'
    })
    :'';
  return '<section class="planner-setup">'
    +'<div class="actions">'+button({label:'← Wybierz inne wędzenie',variant:'ghost',attributes:{'data-planner-cancel':'1'}})+'</div>'
    +message({text:state.notice||'',kind:state.noticeKind||'neutral'})
    +timezoneWarning
    +panel({
      title:state.session.title,
      subtitle:(state.session.recipeDerived?'Szkic utworzony z receptury · ':'')+statusLabel(state.session.status),
      body:'<form id="planner-target-form" class="smoker-form" novalidate>'
        +'<div class="form-grid">'
        +'<label class="field"><span class="field-label">Ma być gotowe</span><input name="targetReadyLocal" type="datetime-local" required></label>'
        +'<label class="field"><span class="field-label">Bufor czasu</span><select name="bufferMinutes">'
          +selectOption('0','Bez bufora',state.bufferMinutes)
          +selectOption('15','15 min',state.bufferMinutes)
          +selectOption('30','30 min',state.bufferMinutes)
          +selectOption('60','60 min',state.bufferMinutes)
        +'</select></label>'
        +'<label class="field"><span class="field-label">Wędzarnia do sprawdzenia</span><select name="smokerId">'+smokerOptions.join('')+'</select></label>'
        +'<label class="field"><span class="field-label">Strefa czasowa</span><input name="timeZone" value="'+escapeHtml(state.timeZone)+'" readonly></label>'
        +'</div>'
        +'<label class="planner-check"><input name="coldSmokingRequired" type="checkbox" value="1"> <span>Ten plan jawnie wymaga zimnego wędzenia</span></label>'
        +'<p class="panel-copy">Dymistrz nie wywnioskuje zimnego wędzenia wyłącznie z temperatury. Zaznacz to tylko wtedy, gdy jest to rzeczywisty wymóg procesu.</p>'
        +'<label class="planner-check"><input name="remindersEnabled" type="checkbox" value="1"'+(state.remindersEnabled?' checked':'')+'> <span>Włącz lokalne przypomnienia przygotowania i startu procesu</span></label>'
        +'<p class="panel-copy">Przypomnienia są lokalne. Przy pierwszym włączeniu system może poprosić o zgodę na powiadomienia.</p>'
        +'<div class="actions">'+button({label:'Wylicz harmonogram',type:'submit',variant:'primary'})+'</div>'
        +'</form>'
    })
    +'</section>';
}

function findingMarkup(finding,review){
  const needsAck=['incompatible','unknown','review'].includes(finding.status);
  const acknowledged=(review.acknowledgedFindingCodes||[]).includes(finding.code);
  const alt=(finding.alternatives||[]).length
    ?'<p class="planner-alternatives">Kontrolowane alternatywy: '+finding.alternatives.map(item=>escapeHtml(item.woodKey)).join(', ')+'</p>'
    :'';
  return '<li class="planner-finding planner-finding-'+escapeHtml(finding.status)+'">'
    +'<div><strong>'+escapeHtml(finding.code)+'</strong><p>'+escapeHtml(finding.message)+'</p>'+alt+'</div>'
    +(needsAck
      ?'<label class="planner-check"><input type="checkbox" data-planner-ack="'+escapeHtml(finding.code)+'"'+(acknowledged?' checked':'')+'> <span>Sprawdziłem / akceptuję ten punkt przed zastosowaniem planu</span></label>'
      :'')
    +'</li>';
}

function compatibilityMarkup(review){
  const compatibility=review.compatibility;
  const findings=compatibility.findings||[];
  if(!findings.length)return '';
  return '<section class="panel planner-compatibility"><div class="panel-heading"><strong>Zgodność z Moją wędzarnią</strong>'
    +'<span>'+escapeHtml(compatibility.status)+'</span></div>'
    +'<ul class="planner-findings">'+findings.map(item=>findingMarkup(item,review)).join('')+'</ul>'
    +'</section>';
}

function blockMarkup(block,timeZone){
  const origin=block.origin==='manual'?'ręcznie zmienione':'wygenerowane';
  const start=block.startAt?formatInstant(block.startAt,timeZone):'brak początku';
  const end=block.endAt?formatInstant(block.endAt,timeZone):'brak końca';
  const uncertainty=block.durationKind==='missing'
    ?'<span class="planner-warning">brak jawnego czasu</span>'
    :block.durationKind==='estimate'
      ?'<span class="planner-warning">czas szacowany</span>'
      :'';
  const generated=block.origin==='manual'
    ?'<small>Wygenerowane: '+escapeHtml(formatInstant(block.generated.startAt,timeZone))+' → '+escapeHtml(formatInstant(block.generated.endAt,timeZone))+' · '+escapeHtml(durationLabel(block.generated.durationMinutes))+'</small>'
    :'';
  const override=block.kind==='buffer'
    ?''
    :'<details class="planner-override"><summary>Zmień ten blok</summary>'
      +'<form class="smoker-form" data-planner-override="'+escapeHtml(block.id)+'">'
      +'<div class="form-grid">'
      +'<label class="field"><span class="field-label">Początek</span><input name="startLocal" type="datetime-local" value="'+escapeHtml(isoToLocalInputValue(block.startAt,{timeZone}))+'"></label>'
      +'<label class="field"><span class="field-label">Koniec</span><input name="endLocal" type="datetime-local" value="'+escapeHtml(isoToLocalInputValue(block.endAt,{timeZone}))+'"></label>'
      +'<label class="field"><span class="field-label">Czas [min]</span><input name="durationMinutes" type="number" min="1" max="525600" value="'+escapeHtml(block.durationMinutes??'')+'"></label>'
      +'</div><div class="actions">'+button({label:'Zastosuj zmianę',type:'submit',variant:'secondary'})+'</div>'
      +'</form></details>';
  return '<li class="planner-block planner-block-'+escapeHtml(block.origin)+'">'
    +'<div class="planner-block-main"><div><strong>'+escapeHtml(block.label)+'</strong>'
    +'<span>'+escapeHtml(start)+' → '+escapeHtml(end)+'</span>'
    +'<span>'+escapeHtml(durationLabel(block.durationMinutes))+' · '+escapeHtml(origin)+'</span>'+uncertainty+generated+'</div></div>'
    +override+'</li>';
}

function impactMarkup(impact){
  if(!impact)return '';
  const shift=impact.shiftMinutes==null
    ?'Wpływ czasowy wymaga ręcznego sprawdzenia.'
    :impact.shiftMinutes===0
      ?'Koniec bloku nie przesunął się względem harmonogramu wygenerowanego.'
      :'Koniec zmienionego bloku przesunął się o '+impact.shiftMinutes+' min względem wersji wygenerowanej.';
  const downstream=(impact.affectedBlockIds||[]).length
    ?' Dalsze bloki w tej samej ścieżce do sprawdzenia: '+impact.affectedBlockIds.length+'.'
    :' Brak dalszych bloków w tej samej ścieżce.';
  const boundary=impact.boundary==='overlap'
    ?' Powstało nakładanie '+Math.abs(impact.boundaryMinutes)+' min.'
    :impact.boundary==='gap'
      ?' Powstała przerwa '+impact.boundaryMinutes+' min.'
      :'';
  return message({text:shift+downstream+boundary,kind:impact.boundary==='overlap'?'warning':'neutral'});
}

function reviewMarkup(state){
  const review=state.review;
  const zone=state.input.timeZone;
  const target=formatInstant(state.input.targetReadyAt,zone);
  const earliest=review.blocks.map(block=>block.startAt).filter(Boolean).sort()[0]||null;
  const warnings=review.generatedSchedule.warnings||[];
  const schedule=review.blocks.map(block=>blockMarkup(block,zone)).join('');

  return '<section class="planner-review">'
    +message({text:state.notice||'',kind:state.noticeKind||'neutral'})
    +'<div class="planner-review-head"><div><span class="eyebrow">Smart Planner</span><h2>'+escapeHtml(state.session.title)+'</h2>'
      +'<p>Gotowe: '+escapeHtml(target)+' · najwcześniejszy krok: '+escapeHtml(formatInstant(earliest,zone))+'</p></div>'
      +statusPill([
        'bufor '+state.input.bufferMinutes+' min',
        state.input.remindersEnabled?'przypomnienia włączone':'bez przypomnień',
        review.complete?'harmonogram kompletny':'wymaga uzupełnienia',
        review.blocks.some(block=>block.origin==='manual')?'ma zmiany ręczne':'bez zmian ręcznych'
      ])
    +'</div>'
    +(warnings.length?message({text:'Harmonogram ma '+warnings.length+' ostrzeżeń dotyczących czasu. Brakujących czasów Dymistrz nie uzupełnia automatycznie.',kind:'warning'}):'')
    +compatibilityMarkup(review)
    +impactMarkup(review.lastImpact)
    +panel({
      title:'Harmonogram od przygotowania do gotowości',
      subtitle:'Każdy dzień i godzina są pokazane jawnie w strefie '+zone+'.',
      body:'<ol class="planner-timeline">'+schedule+'</ol>'
    })
    +(review.missingAcknowledgements.length
      ?message({text:'Przed zastosowaniem planu potwierdź '+review.missingAcknowledgements.length+' punktów wymagających ręcznego sprawdzenia.',kind:'warning'})
      :'')
    +'<div class="actions">'
      +button({id:'planner-apply',label:'Zastosuj harmonogram',variant:'primary',disabled:!review.canApply})
      +button({id:'planner-reset',label:'Przywróć wygenerowany',variant:'secondary'})
      +button({id:'planner-cancel',label:'Anuluj bez zmian',variant:'ghost'})
    +'</div>'
    +'</section>';
}

function appliedMarkup(state){
  return '<section class="planner-applied">'
    +message({text:state.notice||'',kind:state.noticeKind||'success'})
    +panel({
      title:'Harmonogram zapisany',
      subtitle:'W sesji zachowano również audyt wartości wygenerowanych i ręcznie zmienionych.',
      body:'<p class="panel-copy">Plan procesu: '+escapeHtml(formatInstant(state.applied.plannedStartAt,state.input.timeZone))
        +' → '+escapeHtml(formatInstant(state.applied.plannedEndAt,state.input.timeZone))+'.</p>'
        +'<div class="actions"><a class="button button-primary" href="#/smokings">Wróć do Wędzeń</a>'
        +button({label:'Zaplanuj inne wędzenie',variant:'secondary',attributes:{'data-planner-cancel':'1'}})+'</div>'
    })
    +'</section>';
}

export function renderPlannerPage(state){
  if(!state||state.kind==='loading')return loadingState({title:'Ładowanie Smart Plannera',text:'Czytamy lokalne szkice i dane Mojej wędzarni.'});
  if(state.kind==='error')return errorState({title:'Nie udało się otworzyć Smart Plannera',text:'Dane źródłowe nie zostały zmienione.',retryId:'planner-retry'});
  if(state.kind==='setup')return setupMarkup(state);
  if(state.kind==='review')return reviewMarkup(state);
  if(state.kind==='applied')return appliedMarkup(state);
  return listMarkup(state);
}
